import { render, staticRenderFns } from "./OrganRequested.vue?vue&type=template&id=23a0d87d"
import script from "./OrganRequested.vue?vue&type=script&lang=js"
export * from "./OrganRequested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports